import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { environment } from '@analytics/env/environment';
import { catchError, map } from 'rxjs/operators';

export const responseInterceptor: HttpInterceptorFn = (req, next) => {
	return next(req).pipe(
		map((event: HttpEvent<any>) => {
			// should only intercept the requests which are from the api
			if (
				event instanceof HttpResponse &&
				event.url.includes(environment.server) &&
				!event.url.includes(environment.serverNew) &&
				event.body
			) {
				if (event.body.status && event.body.data) {
					// Checks whether a message, like "no_machine_subscription," exists.
					// If such a message is in the body, it returns the message; otherwise, it returns the body.
					event = event.clone({
						body: event.body.msg ? event.body.msg : event.body,
					});
					// If status is false, we check if the data is an array,
					// we set the body to an empty array, otherwise we just return the body.
				} else {
					event = event.clone({ body: Array.isArray(event.body.data) ? [] : event.body });
				}
			}
			return event;
		}),
		catchError((error) => {
			throw error;
		})
	);
};
